import { DetailsMenuItem } from 'shared';
import { CrowndeskAccessRight } from '@crowndesk-core/access-rights/access-rights';

const STOCK_SALES_REPORT_URL = '/stock_sales_reports';

export const CLIENT_MENU: DetailsMenuItem[] = [
  {
    text: 'DASHBOARD',
    url: 'dashboard',
    icon: 'rc-icon-layout-dashboard',
  },
  {
    text: 'MY_COMPANY',
    url: 'clients',
    icon: 'rc-icon-id',
  },
  {
    text: 'MY_DOCUMENTS',
    url: 'documents',
    icon: 'rc-icon-file-text',
    items: [
      {
        text: 'CLIENT_ORDERS',
        url: 'client_orders',
        accessRight: CrowndeskAccessRight.ORDERS,
      },
      {
        text: 'INVOICES',
        url: 'invoices',
        accessRight: CrowndeskAccessRight.BILLING,
      },
      {
        text: 'CREDIT_NOTES',
        url: 'credit-notes',
        accessRight: CrowndeskAccessRight.BILLING,
      },
      {
        text: 'COMPLAINTS',
        url: 'complaints',
      },
      {
        text: 'RETURNS',
        url: 'client_returns',
      },
    ],
  },
  {
    text: 'MY_PRODUCTS',
    url: 'products',
    icon: 'rc-icon-microwave',
    items: [
      {
        text: 'ARTICLES',
        url: 'articles',
      },
      {
        text: 'SUPPLIERS',
        url: 'suppliers',
      },
      {
        text: 'PURCHASE_CONDITIONS',
        url: 'purchase_conditions',
        accessRight: CrowndeskAccessRight.CAN_SEE_PURCHASE_PRICE,
      },
      {
        text: 'PRICE_ADJUSTMENTS',
        url: 'price_adjustments',
        accessRight: CrowndeskAccessRight.CAN_SEE_PURCHASE_PRICE,
      },
    ],
  },
  {
    text: 'MY_TOOLS',
    url: 'tools',
    icon: 'rc-icon-calculator',
    items: [
      {
        text: 'QUOTATION_TOOL',
        url: 'consumer_quotes',
      },
      {
        text: 'ORDER_TOOL',
        url: 'carts',
        accessRight: CrowndeskAccessRight.ORDERS,
      },
      {
        text: 'INTRANET',
        url: 'document_library_folders',
      },
    ],
  },
  {
    // No url of its own: the pages live at the root, so the items link there directly
    text: 'MY_NUMBERS',
    icon: 'rc-icon-chart-line',
    items: [
      {
        text: 'REVENUE',
        url: '/company_revenue',
        accessRight: CrowndeskAccessRight.IS_CROWNDESK_ADMIN,
      },
      {
        text: 'SALES_DATA',
        url: '/sales_data',
        accessRight: CrowndeskAccessRight.BILLING,
      },
      {
        text: 'STOCK_SALES_REPORT',
        url: STOCK_SALES_REPORT_URL,
        accessRight: CrowndeskAccessRight.BILLING,
      },
    ],
  },
  {
    text: 'NEWSLETTERS',
    url: 'newsletters',
    icon: 'rc-icon-mail',
  },
];

/** Only offered when a supplier takes Stock & Sales Reports (`/crown_desk/stock_sales_report_suppliers`). */
export function withoutStockSalesReport(menu: DetailsMenuItem[]): DetailsMenuItem[] {
  return menu.map((item) =>
    item.items ? { ...item, items: item.items.filter((child) => child.url !== STOCK_SALES_REPORT_URL) } : item,
  );
}
